import getFunctionData from "./get-function-data";
import { ENV_DEV } from "./window";

/**
 * GEt element if "is-target"
 * @param {String} input
 * @param {MainClassProps | null} main
 * @returns {Array<Element>}
 */
const getTargetElement = (input, main) => {
  let elements = /** @type {Array<Element>} */ ([]);

  if (input === "parent" && main) {
    const node = /** @type {HTMLElement} */ (main.element.parentElement);
    elements = [node];
  } else {
    /**
     * Attribute selector defined by `attribute(data-*)` converted to regular `[data-*]`
     */
    if (input.startsWith("attribute(")) {
      const data = getFunctionData(input);
      const element = /** @type {String} */ (data.get("parameters"));
      elements = [...document.querySelectorAll(`[${element}]`)];
    } else {
      elements = [...document.querySelectorAll(input)];
    }
  }

  if (ENV_DEV && !elements.length) {
    console.warn(
      `[TorusKit warning]: No target elements found for the query \`${input}\``
    );
  }

  return elements;
}

export default getTargetElement;